import { Card, Dropdown, Table } from 'react-bootstrap';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import Flex from '@/components/common/Flex';
import FalconLink from '@/components/common/FalconLink';
import SessionByBrowserChart from './SessionByBrowserChart';
import TableRow from './TableRow';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useBacklinkSectionHref } from '../../utils/useBacklinkSectionHref';

type SessionByBrowserData = {
  spam_score?: Record<string, number>;
};

type SessionByBrowserProps = {
  data?: SessionByBrowserData;
  noMore?: boolean;
};

const SessionByBrowser = ({
  data,
  noMore = false
}: SessionByBrowserProps) => {
  const moreHref = useBacklinkSectionHref('/backlink/spam-domain');
  const spamScores: Record<string, number> = data?.spam_score ?? {};
  const totalWebSites = Object.values(spamScores).reduce(
    (sum: number, val: number) => sum + val,
    0
  );
  const greenCount = Object.values(spamScores)
    .slice(0, 3)
    .reduce((sum: number, val: number) => sum + val, 0);
  const greenPercentage =
    totalWebSites > 0 ? Math.round((greenCount / totalWebSites) * 100) : 0;
  const warningCount = Object.values(spamScores)
    .slice(3, 6)
    .reduce((sum: number, val: number) => sum + val, 0);
  const warningPercentage =
    totalWebSites > 0 ? Math.round((warningCount / totalWebSites) * 100) : 0;
  const redCount = Object.values(spamScores)
    .slice(6)
    .reduce((sum: number, val: number) => sum + val, 0);
  const redPercentage =
    totalWebSites > 0 ? Math.round((redCount / totalWebSites) * 100) : 0;
  const formattedData = [
    {
      color: 'success',
      percentage: greenPercentage,
      count: greenCount,
      label: 'سایت های سالم'
    },
    {
      color: 'warning',
      percentage: warningPercentage,
      count: warningCount,
      label: 'سایت های کم خطر'
    },
    {
      color: 'danger',
      percentage: redPercentage,
      count: redCount,
      label: 'سایت های خطرناک'
    }
  ];
  const cardRef = useRef<HTMLDivElement>(null);
  return (
    <Card className="h-100" ref={cardRef}>
      <FalconCardHeader
        title={
          <div>
            توزیع اسپم اسکور Moz دامنه‌ها (تجمیع شده){' '}
            <HelpTooltip html="واحد شمارش: دامنه‌های ارجاع‌دهنده. در «بازه‌های ۱۰‌تایی اسپم»، تعداد دامنه‌ها در هر بازهٔ ۱۰ امتیازی نمایش داده می‌شود. در «تجمیع شده مشابه‌ها»، بازه‌ها در سه گروه سالم (۰ تا ۳۰)، کم‌خطر (۳۱ تا ۶۰) و خطرناک (۶۱ تا ۱۰۰) تجمیع می‌شوند." />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={
          <Dropdown
            align="end"
            className="btn-reveal-trigger d-inline-block me-0"
          >
            <Dropdown.Toggle
              className="text-600 btn-reveal"
              split
              variant="reveal"
              size="sm"
            >
              <FontAwesomeIcon icon="ellipsis-h" className="fs--2" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="border py-0">
              <Dropdown.Item className="link-600 fs--1 d-flex align-items-center gap-1 py-1">
                ذخیره تصویر
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  cardRef.current?.requestFullscreen();
                }}
                className="link-600 fs--1 d-flex align-items-center gap-1 py-1"
              >
                تمام صفحه
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        }
      />
      <Card.Body
        as={Flex}
        direction="column"
        justifyContent="between"
        className="py-0"
      >
        <div className="my-auto py-5 py-md-5">
          <SessionByBrowserChart data={formattedData} />
        </div>
        <Table size="sm" className="mb-0" style={{ marginTop: '-35px' }}>
          <thead className="">
            <tr>
              <td className="py-3">
                <Flex alignItems="center">
                  <h6 className="text-600 mb-0 ms-2"></h6>
                </Flex>
              </td>
              <td className="py-3">
                <Flex alignItems="center">
                  <h6 className={`fw-bold mb-0 text-secondary  text-400`}>
                    درصد
                  </h6>
                </Flex>
              </td>
              <td className="py-3">
                <Flex alignItems="center" justifyContent="end">
                  <h6 className="fw-bold mb-0 text-secondary  text-400">
                    تعداد
                  </h6>
                </Flex>
              </td>
            </tr>
          </thead>
          <tbody>
            {/* <TableRow data={['', 'درصد', 'تعداد']} /> */}
            {formattedData.map(item => (
              <TableRow key={item.label} data={item} />
            ))}
          </tbody>
        </Table>
      </Card.Body>
      {!noMore && (
        <Card.Footer className="bg-body-tertiary text-end py-2">
          <FalconLink
            to={moreHref}
            title="بیشتر"
            className="px-0 fw-medium"
          />
        </Card.Footer>
      )}
    </Card>
  );
};

export default SessionByBrowser;
